// eslint-disable-next-line
import styles from './footer.css';

function Footer() {
  return (
    <div className="footer">
      <p>© {new Date().getFullYear()} Posmakujzanzibar.pl</p>
    </div>
  );
}

export default Footer;